import React from "react";
import { postChallengeOneTimePurchasesFromBusinessProfilesIds } from "api/PaymentsAPI";
import { ProductKeys } from "containers/Pricing/products";
import { OneTimePurchaseModel, OneTimePurchaseStatus } from "models/payments/one-time-purchase";

const getSubscriptionFromBusinessProfilesFunction = (productKey: ProductKeys) => {
	switch (productKey) {
		case ProductKeys.Challenges:
			return postChallengeOneTimePurchasesFromBusinessProfilesIds;
	}
};

export const useGetOneTimePurchasesFromBusinessProfiles = (
	businessProfilesIds: number[],
	status: OneTimePurchaseStatus = "all",
	productKey: ProductKeys,
) => {
	const [getOneTimePurchasesState, setGetOneTimePurchasesState] = React.useState({
		oneTimePurchases: [] as OneTimePurchaseModel[],
		isLoading: true,
	});

	const extractSubscriptionsModelsFromResponse = (
		oneTimePurchasesByBusinessProfilesIds: any,
		businessProfilesIds: number[],
	) => {
		const oneTimePurchasesModels: any[] = [];

		businessProfilesIds.forEach((businessProfileId) => {
			const oneTimePurchases = oneTimePurchasesByBusinessProfilesIds[businessProfileId];
			const oneTimePurchaseModels: OneTimePurchaseModel[] = [];

			if (oneTimePurchases && oneTimePurchases.length > 0) {
				oneTimePurchaseModels.push(
					...oneTimePurchases.map((oneTimePurchase: any) => OneTimePurchaseModel.generateFromAPI(oneTimePurchase)),
				);
			} else {
				oneTimePurchaseModels.push(OneTimePurchaseModel.generateEmpty());
			}

			oneTimePurchaseModels.forEach(
				(oneTimePurchaseModel) => (oneTimePurchaseModel.businessProfileId = businessProfileId),
			);
			oneTimePurchasesModels.push(...oneTimePurchaseModels);
		});

		return oneTimePurchasesModels;
	};

	React.useEffect(() => {
		const oneTimePurchaseFromBusinessProfilesFunction = getSubscriptionFromBusinessProfilesFunction(productKey);

		oneTimePurchaseFromBusinessProfilesFunction?.(businessProfilesIds, status)
			.then(({ oneTimePurchases }) => {
				if (oneTimePurchases) {
					const oneTimePurchasesModels = extractSubscriptionsModelsFromResponse(oneTimePurchases, businessProfilesIds);

					setGetOneTimePurchasesState({
						oneTimePurchases: oneTimePurchasesModels,
						isLoading: false,
					});
				} else {
					setGetOneTimePurchasesState({
						...getOneTimePurchasesState,
						isLoading: false,
					});
				}
			})
			.catch(() => {
				setGetOneTimePurchasesState({
					...getOneTimePurchasesState,
					isLoading: false,
				});
			});
	}, []);

	return {
		...getOneTimePurchasesState,
	};
};
